export const REQUISITION_SITE_MODULE_NAME = 'requisition';
export const REQUISITION_WAREHOUSE_MODULE_NAME = 'requisition-execution';
